import { render, staticRenderFns } from "./QueueItemCard.vue?vue&type=template&id=1c644534&scoped=true"
import script from "./QueueItemCard.vue?vue&type=script&lang=js"
export * from "./QueueItemCard.vue?vue&type=script&lang=js"
import style0 from "./QueueItemCard.vue?vue&type=style&index=0&id=1c644534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c644534",
  null
  
)

export default component.exports